import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/dangol-logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    if (!isHome) {
      setIsScrolled(true);
      return;
    }

    const handleScroll = () => {
      const trigger = window.innerHeight * 0.6;
      setIsScrolled(window.scrollY > trigger);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const goToSection = (sectionId) => {
    if (!isHome) {
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          window.scrollTo({ top: section.offsetTop - 80, behavior: 'smooth' });
        }
      }, 100);
      return;
    }
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({ top: section.offsetTop - 80, behavior: 'smooth' });
    }
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="Dangol" />
        </Link>
        <nav className="navigation">
          <ul>
            <li><button type="button" className="nav-link" onClick={() => goToSection('features')}>Features</button></li>
            <li><button type="button" className="nav-link" onClick={() => goToSection('why-dangol')}>About</button></li>
            <li><button type="button" className="nav-link" onClick={() => goToSection('faq')}>FAQ</button></li>
            <li><button type="button" className="nav-link nav-link--cta" onClick={() => goToSection('contact')}>Become a partner</button></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
